export const coins = [
  {
    label: 'Bitcoin',
    value: 'bitcoin',
  },
  {
    label: 'Ethereum',
    value: 'ethereum',
  },
  {
    label: 'Usdt',
    value: 'usdt',
  },
];
